export class Dashboard {
    dashboardId: number;
    dealerGroupId: number;
    dealerShipId: number;
    name: string;
    ordinal: number;
    url: string;
    editMode:boolean;
    constructor (data) {
        this.dashboardId = data.dashboardId;
        this.dealerGroupId =  data.dealerGroupId;
        this.dealerShipId =  data.dealerShipId;
        this.name =  data.name;
        this.ordinal =  data.ordinal;
        this.url =  data.url;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/dashboard/dashboard.ts